import React, { createContext, useEffect, useState } from "react";
import ContentFile from "../../constants/contentFile.json";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  validateEmail,
  validateMobileNumber,
  validateOTP,
} from "../../utils/service";
import { getOTP, loginAPI } from "../../api/Api";
export const LoginPageContext = createContext({});
export const LoginPageContextProvider = ({ children }) => {
  const pageStaticContent = ContentFile.loginPage;
  const navigate = useNavigate();

  const [checkEmailWithOTP, setCheckEmailWithOTP] = useState(true);
  const [checkEmailPassword, SetEmailWithPassword] = useState(false);
  const [showLoader, setShowLoader] = useState(false); //loader
  const [activeTab, setActiveTab] = useState("email");
  const [showErrorPopup, setErrorShowPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successPopupMsg, setSuccessPopupMsg] = useState("");
  const [enableOtpField, setEnableOtpField] = useState(true);
  const [buttonText, setButtonText] = useState("Get OTP");
  const [getOtpButtonDisable, setGetOtpButtonDisable] = useState(true);
  const [EmailValidationCheck, setEmailValidationCheck] = useState(false);

  // Email
  const [emailId, setEmailId] = useState("");
  const [emailValidationMsg, setEmailValidationMsg] = useState("");
  const [seletedLoginType, setSelectedloginType] = useState("emailOTP");
  const [password, setPassword] = useState("");
  const [passwordValdiation, setPasswordValidation] = useState("");

  // Phone number
  const [phoneNumber, setPhoneNumber] = useState("");
  const [numberValidationMsg, setNumberValidationMsg] = useState("");
  const [querystate, setQueryState] = useState("");
  const [queryURI, setQueryURI] = useState("");
  const [loginTypeAmazon, setLoginTypeAmazon] = useState(false);
  // OTP
  const [otpValue, setOtpValue] = useState("");

  const [params] = useSearchParams();

  useEffect(() => {
    const requestState = params.get("state");
    const redirectURI = params.get("redirect_uri");
    const isLoginForAmazon = redirectURI?.includes("amazon");
    setLoginTypeAmazon(isLoginForAmazon);
    setQueryState(requestState);
    setQueryURI(redirectURI);
  }, []);

  // active tab key
  const setKey = (e) => {
    setActiveTab(e);
  };

  // clear input values on tab change
  useEffect(() => {
    if (activeTab === "email") {
      setPhoneNumber("");
      setNumberValidationMsg("");
      setOtpValue("");
      setEmailValidationMsg("");
      setButtonText("Get OTP");
      setEnableOtpField(true);
      setGetOtpButtonDisable(true);
    } else if (activeTab === "phone") {
      setNumberValidationMsg("");
      setEmailId("");
      setEmailValidationMsg("");
      setPassword("");
      setPasswordValidation("");
      setOtpValue("");
      setButtonText("Get OTP");
      setEnableOtpField(true);
      setGetOtpButtonDisable(true);
    } else {
      return;
    }
  }, [activeTab]);

  // clear input values on radio button change
  useEffect(() => {
    if (seletedLoginType === "emailOTP") {
      setEmailId("");
      setEmailValidationMsg("");
      setOtpValue("");
    } else if (seletedLoginType === "emailPassword") {
      setEmailId("");
      setEmailValidationMsg("");
      setPassword("");
      setPasswordValidation("");
    } else {
      return;
    }
  }, [seletedLoginType]);

  useEffect(() => {
    setButtonText("Get OTP");
  }, [emailId, phoneNumber]);

  // function to change radio button selection on Email with OTP
  const onHandleEmailWithOTP = (e) => {
    setSelectedloginType(e.target.id);
    setCheckEmailWithOTP(true);
    SetEmailWithPassword(false);
  };
  // function to change radio button selection on Email with Password
  const onHandleEmailWithPassword = (e) => {
    setSelectedloginType(e.target.id);
    SetEmailWithPassword(true);
    setCheckEmailWithOTP(false);
  };

  // email id onChange function
  const onChangeEmailId = (e) => {
    const emailId = e.target.value;
    setEmailId(emailId);
    emailValidation(emailId);
  };

  // email validation
  const emailValidation = (email) => {
    if (validateEmail(email)) {
      setEmailValidationMsg("");
      setGetOtpButtonDisable(false);
      setEmailValidationCheck(true);
      return true;
    }
    if (EmailValidationCheck === true) {
      checkEmailValidation(email);
    }
  };

  const checkEmailValidation = (email) => {
    if (email === "") {
      setGetOtpButtonDisable(true);
      setEmailValidationMsg("");
      return false;
    } else if (!validateEmail(email)) {
      setEmailValidationMsg("Invalid email");
      setGetOtpButtonDisable(true);
      return false;
    }
  };

  // phone number on chnage function
  const onChangePhoneNumber = (e) => {
    const number = e.target.value;
    if (e.target.value.length === 11) {
      e.preventDefault();
      return;
    }
    onKeyDownNumber(e);
    setPhoneNumber(number);
    phoneNumberValidation(number);
  };

  // onKeyDown phone number
  const onKeyDownNumber = (e) => {
    ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
  };

  // phone number validation
  const phoneNumberValidation = (number) => {
    if (number === "") {
      setGetOtpButtonDisable(true);
      return false;
    } else if (!validateMobileNumber(number)) {
      setGetOtpButtonDisable(true);
      return false;
    } else {
      setGetOtpButtonDisable(false);
      return true;
    }
  };

  //email with password | onchange password input
  const onChangePassword = (e) => {
    const passwordValue = e.target.value;
    setPassword(e.target.value);
    if (passwordValue === "") {
      setPasswordValidation("Password Required");
      return false;
    } else {
      setPasswordValidation("");
      return true;
    }
  };

  // otp onchange function | email with otp
  const onChangeOTP = (e) => {
    const otp = e.target.value;
    if (!/^\d{0,4}$/.test(otp)) {
      return;
    }
    setOtpValue(otp);
    if (!validateOTP(otp)) {
      return false;
    } else {
      onHandleLoginWithOTP(otp);
      return true;
    }
  };

  // onKeyDown otp
  const otpKeyDown = (e) => {
    ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
  };

  // GET OTP [- EMAIL and PHONE -]
  const onHandleGetOTP = async () => {
    const validateEmail = emailValidation(emailId);
    const validateMobileNumber = phoneNumberValidation(phoneNumber);
    let otpData;
    if (activeTab === "phone") {
      if (!validateMobileNumber) {
        return;
      }
      otpData = {
        authType: 1,
        type: 1,
        countryCode: "+91",
        mobile: phoneNumber,
      };
    } else if (activeTab === "email") {
      if (!validateEmail) {
        return;
      }
      otpData = {
        authType: 2,
        type: 1,
        email: emailId,
      };
    } else {
      return;
    }
    setShowLoader(true);
    setButtonText("Resend OTP");
    setGetOtpButtonDisable(false);
    try {
      const response = await getOTP(otpData);
      if (response?.status === 200) {
        setShowSuccessPopup(true);
        setSuccessPopupMsg(response?.data?.message);
        setEnableOtpField(false);
      }
    } catch (error) {
      setErrorShowPopup(true);
      setErrorPopupMessage(error?.response?.data?.message);
    }
    setShowLoader(false);
  };

  // LOGIN WITH OTP
  const onHandleLoginWithOTP = async (otp) => {
    setShowLoader(true);
    let loginData;
    if (activeTab === "email") {
      loginData = {
        loginType: 3,
        email: emailId,
        otp: otp,
        fcmToken: "",
        state: querystate,
        redirect_uri: queryURI,
      };
    } else if (activeTab === "phone") {
      loginData = {
        loginType: 1,
        mobile: phoneNumber,
        countryCode: "+91",
        otp: otp,
        fcmToken: "",
        state: querystate,
        redirect_uri: queryURI,
      };
    }
    try {
      const response = await loginAPI(loginData);
      if (response?.status === 200) {
        const redirect_url = response?.data?.redirect_uri;
        window.location.replace(redirect_url);
      }
    } catch (error) {
      setOtpValue("");
      setErrorShowPopup(true);
      setErrorPopupMessage("Invalid credentials");
    }
    setShowLoader(false);
  };

  // LOGIN with email id and password
  const onHandleLogin = async () => {
    setShowLoader(true);
    const loginData = {
      loginType: 2,
      email: emailId,
      password: password,
      fcmToken: "",
      state: querystate,
      redirect_uri: queryURI,
    };
    try {
      const response = await loginAPI(loginData);
      if (response?.status === 200) {
        const redirect_url = response?.data?.redirect_uri;
        window.location.replace(redirect_url);
      }
    } catch (error) {
      setErrorShowPopup(true);
      setErrorPopupMessage(error?.response?.data?.message);
    }
    setShowLoader(false);
  };

  // function to active Login button after input filled
  const buttonEnableStatus = (() => {
    if (
      emailId &&
      password &&
      emailValidationMsg === "" &&
      passwordValdiation === ""
    ) {
      return true;
    } else {
      return false;
    }
  })();

  // Error popup cancel function
  const onClickPopuptryAgain = () => {
    setErrorShowPopup(false);
  };

  // Cancel success popup
  const onClickContinueButton = () => {
    setShowSuccessPopup(false);
  };

  const ProviderValue = {
    pageStaticContent, // page static content
    onHandleEmailWithOTP,
    onHandleEmailWithPassword,
    checkEmailWithOTP,
    checkEmailPassword,
    showLoader, // Loader status
    setKey,
    showErrorPopup, // pop state
    errorPopupMessage, //popup message state
    showSuccessPopup, //success popup state
    successPopupMsg, //success popup message state

    onClickPopuptryAgain, // on click error popup try again button
    onClickContinueButton, // on click success popup continue button

    // Email
    onChangeEmailId, // email onchange
    emailId, // email state
    emailValidationMsg, // email validation message state

    // Phone number
    onChangePhoneNumber, // phone number onChange
    phoneNumber, // phone number state
    numberValidationMsg, // phone number validation state

    // otp
    onChangeOTP, // otp onChange
    otpValue, //otp state

    onHandleGetOTP, // function to get otp
    onHandleLogin, // onclick login

    onChangePassword, //email with password | onchange password input
    password, // email with password |  password contain state
    passwordValdiation, // email with password |  password validation message

    buttonEnableStatus, // Login button status change
    // onkeyDown otp
    otpKeyDown,

    // onKeyDown phone number
    onKeyDownNumber,

    enableOtpField, // enable otp field after getting otp

    buttonText, // get otp button text

    getOtpButtonDisable, // get otp button disable state
    loginTypeAmazon, // login for amazon
  };
  return (
    <LoginPageContext.Provider value={ProviderValue}>
      {children}
    </LoginPageContext.Provider>
  );
};
